export enum FormRuleMenuOption {
    EDIT_NAME = 'EDIT_NAME',
    ENABLE = 'ENABLE',
    DISABLE = 'DISABLE',
    DELETE = 'DELETE',
}
